module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/vendor/my-vendor/vendor-contact/vendor-contact.component.scss
// module id = ./src/app/pages/vendor/my-vendor/vendor-contact/vendor-contact.component.scss
// module chunks = main